import { resetSessionExpiryFlag } from "@/utils/apiErrorHandler";
import { authService } from "./authServiceInstance";

let refreshPromise: Promise<void> | null = null;

/**
 * Ensures only one silent refresh happens at a time.
 * All callers await the same promise.
 */
export const refreshSession = async (): Promise<void> => {
  if (!refreshPromise) {
    refreshPromise = authService.UserManager.signinSilent()
      .then(() => {
        resetSessionExpiryFlag();
      })
      .catch((error) => {
        console.error("Silent sign-in failed:", error);
        throw error; // Re-throw to maintain promise rejection
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  // eslint-disable-next-line @typescript-eslint/return-await
  return refreshPromise;
};
